'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = require('react-bootstrap');

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SubSectionHeaderComponent = require('./SubSectionHeaderComponent');

var _SubSectionHeaderComponent2 = _interopRequireDefault(_SubSectionHeaderComponent);

var _TextInputComponent = require('../input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _DatePickerComponent = require('../input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _SelectComponent = require('../input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _RadioGroupComponent = require('../input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _PropTypes = require('../../validators/common/PropTypes');

var _translate = require('../../language/translate');

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a single additional applicant component for the form.
 */
var BeneficiaryComponent = function BeneficiaryComponent(_ref) {
  var context = _ref.context,
      dynamicFieldIndex = _ref.dynamicFieldIndex,
      inputComponentField = _ref.inputComponentField,
      _onChangeHook = _ref.onChangeHook,
      formValues = _ref.formValues,
      formConfig = _ref.formConfig;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _SubSectionHeaderComponent2.default,
      null,
      (0, _translate.t)('Beneficiary') + ' ' + (dynamicFieldIndex + 1)
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'benefeciaryFirstName',
        inputLabel: 'First Name',
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.first_name
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'benefeciaryLastName',
        inputLabel: 'Last Name',
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.last_name
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'benefeciaryEmail',
        inputLabel: 'Email',
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.email
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'benefeciaryPhoneNumber',
        inputLabel: 'Phone Number',
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.phone_number
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'relationship_to_insured',
        inputLabel: 'Relationship to Insured',
        hasExpandableHint: true,
        expandableHintId: 'relationshiptoinsured',
        expandableHintTitle: context.formConfig.beneficiary.relationship_to_insured.title,
        expandableHintContent: context.formConfig.beneficiary.relationship_to_insured.hint,
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.relationship
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'benefit_payout',
        inputLabel: 'Benefit Payout',
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.payout,
        inputComponentProps: {
          onChangeHook: function onChangeHook() {
            _onChangeHook(context);
          },
          type: 'percentage'
        }
      })
    )
  );
};

BeneficiaryComponent.propTypes = {
  dynamicFieldIndex: _react2.default.PropTypes.number.isRequired,
  inputComponentField: _react2.default.PropTypes.object.isRequired,
  onChangeHook: _react2.default.PropTypes.func,
  formValues: _react2.default.PropTypes.object.isRequired,
  formConfig: _react2.default.PropTypes.object,
  context: _react2.default.PropTypes.object.isRequired
};

exports.default = BeneficiaryComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/BeneficiaryComponent.jsx
// module id = 1659
// module chunks = 0